import { z } from "zod";
import { useQuery } from "@tanstack/react-query";

const intercomAuthSchema = z.object({ token: z.string() });

export const useIntercomToken = ({
  userId,
  getIntercomToken,
}: {
  /** The Intercom user the token is for, so one user's token is never served to another. */
  userId: string;
  getIntercomToken: () => Promise<unknown>;
}) =>
  useQuery({
    queryKey: ["intercom", "token", userId],
    queryFn: async () =>
      intercomAuthSchema.parse(await getIntercomToken()).token,
    staleTime: 90 * 60 * 1000, // 90 minutes in milliseconds
  });
